<!-- navスライダー -->
<template>
  <swiper
    class="crly-m-contents-category-list"
    :options="swiperOption"
    @clickSlide="onSwiperClickSlide"
  >
    <template v-for="item in itemList">
      <swiper-slide
        :key="item.class"
        :class="[item.class, { on: type == item.class }]"
        class="crly-icon"
      >
        <span class="crly-icon-txt"></span>
      </swiper-slide>
    </template>
  </swiper>
</template>

<script>
export default {
  name: "CrlyMoleculesContentsCategoryList",
  props: {
    /**
     * カテゴリ一覧
     */
    itemList: {
      type: Array,
      default: () => []
    },
    /**
     * カテゴリ
     */
    type: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 6,
        spaceBetween: 0
      }
    };
  },
  methods: {
    /**
     * Navアイテムクリックイベント
     */
    onSwiperClickSlide(index) {
      const linkName = this.itemList[index].linkName;
      if (linkName !== this.$route.name) {
        // 表示中の画面と遷移先の画面が同じだとエラーになるので、異なる場合のみ遷移する
        this.$router.push({ name: this.itemList[index].linkName });
      }
    }
  }
};
</script>

<style lang="scss">
@import "@crly/assets/css/molecules/contents/categoryList.scss";
</style>
